// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__qC5Gd","list":"BalanceDue_list__2TOSE","listRow":"BalanceDue_listRow__3TCUE","total":"BalanceDue_total__2bM3X"};